import { retrieveCurrencyConversionRate } from '../../../../shared/currencyConversionUtil'
import { BonusBetweenAnnualBonusAndProrataDto, Currency, CurrencyConversionDto, ContractChangeFragment, TargetBonusOfYearFragment } from '../../../../types'
import { canUseFlexibleBonusAsReference, ContractWithValidity, FlexibleBonusOverride } from './targetBonusCalculation-util'

export const getFlexibleBonusUnknownCurrencyForConversion = (
  bonus: Pick<BonusBetweenAnnualBonusAndProrataDto, 'bonusAmount' | 'contractId' | 'contractCurrency'> | null | undefined,
  currentContractCurrency: Currency,
  currencyConversionData: CurrencyConversionDto[],
): Currency | undefined => {
  if (!bonus || bonus.contractCurrency === currentContractCurrency) {
    return undefined
  }

  const conversionRate: number | undefined = retrieveCurrencyConversionRate(
    bonus.contractCurrency,
    currentContractCurrency,
    currencyConversionData,
  )

  return conversionRate ? undefined : bonus.contractCurrency
}

export const getConvertedFlexibleBonusAmount = (
  bonus: Pick<BonusBetweenAnnualBonusAndProrataDto, 'bonusAmount' | 'contractId' | 'contractCurrency'> | null | undefined,
  currentContractCurrency: Currency,
  currencyConversionData: CurrencyConversionDto[],
): number | undefined => {
  return toFlexibleBonusOverride(bonus, currentContractCurrency, currencyConversionData)?.bonusAmount
}

export const toFlexibleBonusOverride = (
  bonus: Pick<BonusBetweenAnnualBonusAndProrataDto, 'bonusAmount' | 'contractId' | 'contractCurrency'> | null | undefined,
  currentContractCurrency: Currency,
  currencyConversionData: CurrencyConversionDto[],
): FlexibleBonusOverride | undefined => {
  if (!bonus) {
    return undefined
  }

  let bonusAmount = bonus.bonusAmount
  if (bonus.contractCurrency !== currentContractCurrency) {
    const conversionRate: number | undefined = retrieveCurrencyConversionRate(
      bonus.contractCurrency,
      currentContractCurrency,
      currencyConversionData,
    )
    if (!conversionRate) {
      return undefined
    }
    bonusAmount = Number((bonusAmount * conversionRate).toFixed(2))
  }

  return {
    bonusAmount,
    contractId: bonus.contractId,
  }
}

export const toEligibleFlexibleBonusOverride = (
  bonus: Pick<BonusBetweenAnnualBonusAndProrataDto, 'bonusAmount' | 'contractId' | 'contractCurrency'> | null | undefined,
  currentContractCurrency: Currency,
  currencyConversionData: CurrencyConversionDto[],
  employeeTimezone: string,
  year: number,
  contractsInYear: ContractWithValidity[],
  targetBonusList: TargetBonusOfYearFragment[],
  contractChanges: ContractChangeFragment[] = [],
): FlexibleBonusOverride | undefined => {
  if (!canUseFlexibleBonusAsReference(employeeTimezone, year, contractsInYear, targetBonusList, contractChanges)) {
    return undefined
  }

  return toFlexibleBonusOverride(bonus, currentContractCurrency, currencyConversionData)
}
